'use strict';

/**
 * Created by lzy 19-11-03
 * 头条号废稿箱待编
 */
angular.module('editToutiaohaoDraftBoxModule', ['editToutiaohaoDraftBoxRouterModule']).controller('EditToutiaohaoDraftBoxCtrl', [
    '$scope',
    '$state',
    '$q',
    '$filter',
    'modalDialog',
    'trsHttpService',
    'editingCenterService',
    'trsspliceString',
    'toutiaohaoService',
    'editcenterRightsService',
    'editingMediatype',
    function(
        $scope,
        $state,
        $q,
        $filter,
        modalDialog,
        trsHttpService,
        editingCenterService,
        trsspliceString,
        toutiaohaoService,
        editcenterRightsService,
        editingMediatype
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                isSearch: false
            };
            $scope.data = {
                selectedArray: [],
                items: [],
                keyWords: '',
                account: $state.params.account,
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
        }

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            // 初始化选择类型
            $scope.data.docTypeJsons = toutiaohaoService.initSelect();
            $scope.data.docType = angular.copy($scope.data.docTypeJsons[0]);
            requestData();
            initBtnRights();
        }

        /**
         * [requestData description]数据请求
         * @return {[type]} [description]
         */
        function requestData() {
            var initparams = {
                serviceid: 'mlf_toutiao',
                methodName: 'queryAbolishedArticles',
                CHANNELID: $state.params.account,
                PageSize: $scope.page.PAGESIZE,
                CurrPage: $scope.page.CURRPAGE,
                timeType: 0,
                OperTimeStart: $scope.data.fromdate,
                OperTimeEnd: $scope.data.untildate,
                searchKeyWord: $scope.data.keyWords,
            };
            var params = $scope.status.isSearch ? getESSearchParams() : initparams;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (!$scope.status.isSearch) {
                    $scope.data.keyWords = '';
                }
                $scope.data.items = data.DATA;
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                $scope.data.selectedArray = [];
            });
        }

        /**
         * [getESSearchParams description] 处理ES搜索参数
         *
         * @return  {[type]}  [return description]
         */
        function getESSearchParams() {
            var esparams = {
                serviceid: 'mlf_hybasesearch',
                methodname: 'queryForNewMediaDoc',
                mediaType: editingMediatype.toutiaohao,
                searchParams: {
                    PAGESIZE: $scope.page.PAGESIZE,
                    PAGEINDEX: $scope.page.CURRPAGE,
                    CHANNELID: $state.params.account,
                    status_model: '-1', 
                    searchFields: [
                        {
                            searchField: '',
                            keywords: $scope.data.keyWords,
                        },
                        {
                            searchField: 'docType',
                            keywords: $scope.status.dockind || '',
                        },
                        {
                            searchField: 'timeType',
                            keywords:
                                angular.isDefined($scope.data.fromdate) && $scope.data.fromdate !== ''
                                    ? $scope.data.fromdate + ',' + $scope.data.untildate
                                    : '',
                        },
                        {
                            searchField: '_sort',
                            keywords: 'time',
                        },
                    ],
                }
            };
            esparams.searchParams = JSON.stringify(esparams.searchParams);
            return esparams;
        }
        // 初始化头条号操作权限
        function initBtnRights() {
            editcenterRightsService.initToutiaohaoListBtn('toutiao.recyclemgr', $state.params.account).then(function(rights) {
                $scope.status.btnRights = rights;
            });
        }
        // 全选
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc description]单选
         * @param  {[obj]} item [description]稿件信息
         * @return {[type]}     [description]
         */
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        // 按照条件搜索
        $scope.queryByDropdown = function(type, val) {
            if (type === 'DocType') {
                $scope.data.docType = val;
            }
            // $scope.page.CURRPAGE = 1;
            requestData();
            // $scope.fullTextSearch();
        };

        /**
         * [isChecked description] 选中状态
         * @param  {[type]}  item [description]
         * @return {Boolean}      [description]
         */
        $scope.isChecked = function(item) {
            if (!item) {
                return;
            }
            var ischecked = false;
            for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                if ($scope.data.selectedArray[i].CHNLDOCID == item.CHNLDOCID) {
                    ischecked = true;
                    break;
                }
            }
            return ischecked;
        };

        /**
         * [fullTextSearch description]搜索
         * @param  {[type]} ev [description]
         * @return {[type]}    [description]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.status.isSearch = true;
                $scope.page.CURRPAGE = 1;
                requestData();
            }
        };

        /**
         * [restore description]稿件还原
         * @return {[type]} [description]
         */
        $scope.restore = function() {
            modalDialog.confirmModal('', '确定还原？', function() {
                var params = {
                    serviceid: 'mlf_toutiaooper',
                    methodName: 'restoreAbolishedArticles',
                    CHANNELID: $state.params.account,
                    ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
                };
                $scope.status.isSearch = false;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    requestData();
                    modalDialog.alertType('稿件还原成功', '', 'success', false);
                });
            });
        };

        /**
         * [delete description]稿件删除
         * @return {[type]} [description]
         */
        $scope.delete = function() {
            // if($scope.data.selectedArray.length > 1) {
            //     modalDialog.alertType('', '每次最多删除一个稿件', 'info');
            //     return;
            // };
            modalDialog.confirmModal('', '确定删除？', function() {
                var params = {
                    serviceid: 'mlf_toutiaooper',
                    methodName: 'deleteTouTiaoArticles',
                    CHANNELID: $state.params.account,
                    ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
                };
                $scope.status.isSearch = false;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    requestData();
                    modalDialog.alertType('稿件删除成功', '', 'success', false);
                });
            });
        };

        /**
         * [clearTrash description]清空废稿箱
         * @return {[type]} [description]
         */
        $scope.clearTrash = function() {
            modalDialog.confirmModal('', '确定清空？', function() {
                var params = {
                    serviceid: 'mlf_toutiaooper',
                    methodName: 'clearScrapBox',
                    CHANNELID: $state.params.account,
                };
                $scope.status.isSearch = false;
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                    function() {
                        modalDialog.alertType('', '清空废稿箱成功', 'success', true);
                        requestData();
                    },
                    function(data) {
                        modalDialog.alertType('', '清空废稿箱失败', 'error', 'confirm');
                    }
                );
            });
        };

        /**
         * [pageChanged description]翻页
         */
        $scope.pageChanged = function() {
            $scope.loadingPromise = requestData();
        };

        /**
         * [jumpToPage description]跳页
         */
        $scope.jumpToPage = function() {
            $scope.page.CURRPAGE = angular.copy($scope.status.copyCurrPage);
            $scope.loadingPromise = requestData();
        };

        /**
         * [showVersionTime description]展示流程版本与操作日志
         * @param  {[str]} item [description]
         * @return {[type]}            [description]
         */
        $scope.showVersionTime = function(item) {
            editingCenterService.getVersionTime(item, false);
        };
    },
]);
